import { jsx as _jsx } from "react/jsx-runtime";
import { Field } from "react-final-form";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const FieldWrapper = ({ name , onBlur , onClick , ...props })=>{
    const blurable = props.type !== "checkbox" && props.type !== "radio";
    const wrappedOnClick = (e)=>{
        if (onClick) onClick(e);
        if (!blurable) {
            return name;
        }
        return;
    };
    const wrappedOnBlur = (e)=>{
        if (onBlur) onBlur(e);
        if (e.target && blurable) {
            return name;
        }
        return;
    };
    return /*#__PURE__*/ _jsx(Field, {
        name: name,
        onBlur: wrappedOnBlur,
        onClick: wrappedOnClick,
        ...props
    });
};
export default FieldWrapper;
